import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { CTA_URL } from "../data/site";

export const ExtLink = ({ href = CTA_URL, children, className = "", testid }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" className={className} data-testid={testid}>
    {children}
    <ArrowUpRight aria-hidden="true" className="inline h-4 w-4" />
    <span className="sr-only"> (opens in a new tab)</span>
  </a>
);

export const BtnPrimary = ({ to, children, testid }) => (
  <Link to={to} data-testid={testid} className="btn-flame group">
    {children}
    <ArrowRight aria-hidden="true" className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
  </Link>
);

export const CtaExt = ({ children = "Get a site like this", testid, dark = true }) => (
  <ExtLink testid={testid} className={dark ? "btn-ghost-light" : "btn-ghost-dark"}>
    {children}
  </ExtLink>
);

export const Eyebrow = ({ children, light = false }) => (
  <p className={`eyebrow ${light ? "text-flame-soft" : "text-flame-deep"}`}>{children}</p>
);

export const TextLink = ({ to, children, testid }) => (
  <Link to={to} data-testid={testid} className="link-u inline-flex items-center gap-2 font-semibold text-ink">
    {children}
    <ArrowRight aria-hidden="true" className="h-4 w-4" />
  </Link>
);

export const Crumbs = ({ items, light = true }) => (
  <nav aria-label="Breadcrumb" className="mb-8">
    <ol className={`flex flex-wrap items-center gap-2 text-sm ${light ? "text-mist" : "text-slate2"}`}>
      {items.map((c, i) => (
        <li key={c.to || c.label} className="flex items-center gap-2">
          {i > 0 && <span aria-hidden="true">/</span>}
          {c.to ? <Link className="link-u" to={c.to}>{c.label}</Link> : <span aria-current="page">{c.label}</span>}
        </li>
      ))}
    </ol>
  </nav>
);
